import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { initializeI18n } from "@/config/i18nConfig";
import { App } from "./App";
import "@cloudaccelerator-ui/react-library/style.css";
import "./index.css";
import "./globals.scss";

const container = document.getElementById("root");

if (container === null) {
  throw new Error("Root element not found. Make sure there is a <div id='root'></div> in your HTML.");
}

// Initialize i18next before rendering so library's LocaleProvider works
initializeI18n().then((): void => {
  const root = createRoot(container);

  root.render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
